import React, { useState, useEffect } from 'react';
import { Calendar } from 'lucide-react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const BookingButton = () => {
  const [bookingLink, setBookingLink] = useState(null);

  useEffect(() => {
    const fetchLink = async () => {
      try {
        const res = await axios.get(`${API}/booking-link`);
        setBookingLink(res.data);
      } catch (e) {
        console.error('Error fetching booking link:', e);
      }
    };
    fetchLink();
  }, []);

  if (!bookingLink || !bookingLink.url) return null;

  return (
    <a
      href={bookingLink.url}
      target="_blank"
      rel="noopener noreferrer"
      className="flex items-center gap-2.5 px-6 py-3 rounded-full font-semibold text-base transition-all hover:scale-105 shadow-lg shadow-amber-900/30 hover:shadow-amber-700/40"
      style={{
        background: 'linear-gradient(135deg, #92400e, #b45309, #d97706, #b45309, #92400e)',
        color: '#fef3c7',
        border: '1.5px solid rgba(251, 191, 36, 0.4)',
      }}
      data-testid="booking-btn"
    >
      <Calendar className="w-5 h-5" />
      <span>{bookingLink.label || "Réserver vos séances d'hypnose"}</span>
    </a>
  );
};

export default BookingButton;
